<template>
    <div
            class="check-mark"
            :class="{
                'check-mark_active': localValue === true,
                'check-mark_disabled': disabled,
                'check-mark_mobile': $vuetify.breakpoint.xsOnly
            }"
            @click="changeMark()"
    >
        <i
          v-if="!loading"
          class="v-icon mdi mdi-check"
        ></i>
        <i
          v-if="loading"
          class="v-icon mdi mdi-loading check-mark__loading"
        ></i>
    </div>
</template>

<script>
    export default {
        props: {
            value: Boolean,
            id: null,
            subId: null,
            actionChangeFalse: null,
            actionChangeTrue: null,
            disabled: {type: Boolean, default: false},
            customPayload: {type: Function, default: null},
            loading: {type: Boolean, default: false},
        },
        data() {
            return {
                localValue: this.value
            }
        },
        watch: {
            value(value) {
                this.localValue = value;
            },
            subId() {
                this.localValue = this.value;
            }
        },
        methods: {
            changeMark() {
                if (this.disabled) return;

                if (this.localValue === false) {
                    this.localValue = true;
                } else {
                    this.localValue = false;
                }

                this.sendStatus();
            },
            sendStatus() {
                let action = '';
                let statusOld = '';

                if (this.localValue === false) {
                    action = this.actionChangeFalse;
                    statusOld = true;
                } else if (this.localValue === true) {
                    action = this.actionChangeTrue;
                    statusOld = false;
                } else {
                    return;
                }

                let payload = {id: this.id, subId: this.subId};

                if (!!this.customPayload) payload = this.customPayload(payload, this.id, this.localValue);

                this.$store.dispatch(action, payload)
                    .then(() => this.$emit('input', this.localValue))
                    .catch(() => this.localValue = statusOld);
            }
        },
        created() {
            this.localValue = this.value;
        }
    }
</script>

<style lang="scss">
    @import 'src/assets/scss/vars';

    .check-mark {
        width: 20px;
        height: 20px;
        border: 1px solid #888;
        border-radius: 50%;
        color: #888;
        display: flex;
        justify-content: center;
        cursor: pointer;
        background-color: #fff;

        &:hover {
            color: $colorPrimary;
            border-color: $colorPrimary;
        }
        &.check-mark_active {
            color: #fff;
            background-color: $colorPrimary;
            border-color: $colorPrimary;
        }
        &.check-mark_disabled {
            cursor: default;
            opacity: 0.5;
        }
        &.check-mark_mobile {
            width: 30px;
            height: 30px;
            min-width: 30px;
        }
        i.v-icon {
            font-size: 17px;
        }
        .check-mark__loading {
          animation: rotation 1s linear infinite;
        }
    }
</style>